import Graphics = createjs.Graphics;
import Shape = createjs.Shape;

export const GAME_STAGE = "gamestage";
export const UI_STAGE = "uiStage";
export const BG_STAGE = "bgStage";
export const STATIC_STAGE = "staticStage";
export const TUTORIAL_STAGE = "tutorialStage";

export function objectsUnderPoint(container: (createjs.Stage | createjs.Container) & any, ctx: CanvasRenderingContext2D, x: number, y: number, arr: any[] | null, mouse: boolean, activeListener?: any, currentDepth?: any, hitTestTime?:number): createjs.DisplayObject | null {
    currentDepth = currentDepth || 0;
    hitTestTime = hitTestTime || Date.now();
    let scaleX = 1;
    let scaleY = 1;

    if( container.stage ) {
        scaleX = 1 / container.stage.scaleX;
        scaleY = 1 / container.stage.scaleY;
    }

    if (!currentDepth && !container._testMask(container, x, y)) {
        return null;
    }

    activeListener = activeListener || (mouse && container._hasMouseEventListener());

    // draw children one at a time, and check if we get a hit:
    const children = container.children,
        l = children.length;
    for (let i = l - 1; i >= 0; i--) {
        const child = children[i];
        const hitArea = child.hitArea;
        if (!child.visible || (mouse && !child.mouseEnabled) || (!hitArea && !child.isVisible())) {
            continue;
        }
        if (!hitArea && !container._testMask(child, x, y)) {
            continue;
        }
        // if a child container has a hitArea then we only need to check its hitArea, so we can treat it as a normal DO:
        if (!hitArea && child instanceof createjs.Container) {
            /*Gets the boundary of the current object, then checks to see if the mouse is within it.  If it is not then continue.
that prevents child objects being needlessly evaluated.*/
            let result;
            // getBounds is expensive for large containers, so we bypass them
            let skipLayer = 0;
            if (currentDepth > skipLayer) {
                let cb = child.getHitTestBounds(hitTestTime, container.stage);
                // Check mouse is inside the boundary of current child
                if (x >= cb.x && x <= cb.right && y >= cb.y && y <= cb.y + cb.height) {
                    result = child.__getObjectsUnderPoint(x, y, arr!, mouse, activeListener, currentDepth + 1, hitTestTime);
                }
            } else {
                result = child.__getObjectsUnderPoint(x, y, arr!, mouse, activeListener, currentDepth + 1, hitTestTime);
            }
            if (!arr && result) {
                return mouse && !container.mouseChildren ? container : result;
            }
        } else {
            if (mouse && !activeListener && !child._hasMouseEventListener()) {
                continue;
            }
            if (child.stage && child.stage.name === BG_STAGE) {
                // hit it directly
                return mouse && !container.mouseChildren ? container : child;
            }
            // TODO: can we pass displayProps forward, to avoid having to calculate that backwards every time? It's kind of a mixed bag. When we're only hunting for DOs with event listeners, it may not make sense.
            let cw = child.width / child.scaleX, ch = child.height / child.scaleY;
            const props = child.getConcatenatedDisplayProps(child._props);
            const mtx = props.matrix;
            if (hitArea) {
                mtx.appendMatrix(hitArea.getMatrix(hitArea._props.matrix));
                props.alpha = hitArea.alpha;
            }
            mtx.scale(scaleX,scaleY);
            mtx.tx = mtx.tx * scaleX;
            mtx.ty = mtx.ty * scaleY;
            if (Math.abs(mtx.b) < 0.01 && Math.abs(mtx.c) < 0.01) {
                let simpleHitTest = true, area = hitArea || child, canMeasureBounds = true;
                if (area instanceof Shape) {
                    let g = area.graphics;
                    for (let k = 0; k < g.instructions.length; k++) {
                        if ( k > 20) {
                            canMeasureBounds = false;
                            break;
                        }
                        let ins = g.instructions[k];
                        if (ins instanceof Graphics.QuadraticCurveTo || ins instanceof Graphics.BezierCurveTo) {
                            canMeasureBounds = false;
                            break;
                        }
                    }
                    if (canMeasureBounds && g.bounds) {
                        cw = g.bounds.width;
                        ch = g.bounds.height;
                    }
                }
                if (canMeasureBounds) {
                    // handle scaled object
                    cw *= Math.abs(mtx.a);
                    ch *= Math.abs(mtx.d);
                    if (mtx.a > 0 && mtx.d > 0) {
                        simpleHitTest = x >= mtx.tx && x <= mtx.tx + cw && y >= mtx.ty && y <= mtx.ty + ch;
                    } else if (mtx.a < 0 && mtx.d > 0) {
                        simpleHitTest = x >= mtx.tx - cw && x <= mtx.tx  && y >= mtx.ty && y <= mtx.ty + ch;
                    } else if (mtx.a > 0 && mtx.d < 0) {
                        simpleHitTest = x >= mtx.tx && x <= mtx.tx + cw && y >= mtx.ty - ch && y <= mtx.ty;
                    } else if (mtx.a < 0 && mtx.d < 0) {
                        simpleHitTest = x >= mtx.tx - cw && x <= mtx.tx && y >= mtx.ty - ch && y <= mtx.ty;
                    }
                    if (!simpleHitTest) {
                        continue;
                    } else if ( !(window as any).restrictedInteractiveArea && child.stage.name === UI_STAGE) {
                        // if background or uiStage, we dont need hitTest
                        return mouse && !container.mouseChildren ? container : child;
                    }
                }
            }
            ctx.globalAlpha = props.alpha;
            ctx.setTransform(mtx.a, mtx.b, mtx.c, mtx.d, mtx.tx - x, mtx.ty - y);
            (hitArea || child).draw(ctx);
            if (!container._testHit(ctx)) {
                continue;
            }
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, 2, 2);
            if (arr) {
                arr.push(child);
            } else {
                return mouse && !container.mouseChildren ? container : child;
            }
        }
    }
    return null;
}
